export const SET_SELECTED_ITEM = "SET_SELECTED_ITEM";
export const HANDLE_OPEN_NAV_ITEM = "HANDLE_OPEN_NAV_ITEM";

export const setNavLink = (string) => ({
    type: SET_SELECTED_ITEM,
    string
});

export const handleOpenNavItem = (string) => ({
    type: HANDLE_OPEN_NAV_ITEM,
    string
});